<template>
  <div class="ManageContent">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <div class="container-fluid">
        <Manage-Content-Tab @clickedTab='activeTab'></Manage-Content-Tab>
        <manage-course v-if="currentSelectedTab === 1"></manage-course>
        <Manage-Group v-if="currentSelectedTab === 2"></Manage-Group>
        <Manage-Group-Course v-if="currentSelectedTab === 3"></Manage-Group-Course>
        <Manage-Cohorts v-if="currentSelectedTab === 4"></Manage-Cohorts>
      </div>  
      <div class="row margin-Top-3Perc">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <Copyright-Element class="footer"></Copyright-Element>
          </div>
      </div>
    </div>  
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
    <error-page v-if="isUserGroupAdmin"></error-page>       
  </div>  
</template>

<script>
import ManageCourse from '@/components/ManageCourse'
import ManageContentTab from '@/components/ManageContentTab'
import ManageGroup from '@/components/ManageGroup'
import ManageGroupCourse from '@/components/ManageGroupCourse'
import ManageCohorts from '@/components/ManageCohorts'
import CopyrightElement from '@/components/CopyrightElement'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import ErrorPage from '@/pages/Error'
import AlertBox from '@/components/AlertOverlay'
import { participantService } from '@/server-util/participant-service'
export default {
  data: function () {
    return {
      currentSelectedTab: 1,
      showAlertDialog: false,
      errorMsg: ''
    }
  },
  components: {
    'Manage-Content-Tab': ManageContentTab,
    'manage-course': ManageCourse,
    'Manage-Group': ManageGroup,
    'Manage-Group-Course': ManageGroupCourse,
    'Manage-Cohorts': ManageCohorts,
    'Copyright-Element': CopyrightElement,
    'error-page': ErrorPage,
    'alert-box': AlertBox
  },
  created: function () {
    this.trackPageLoad()
    this.checkUserErrorStatus()
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    activeTab (newValue) {
      this.currentSelectedTab = newValue
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Manage Content Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Manage_Files,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'MANAGE CONTENT',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    }
  },
  computed: {
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'ManageContent'
}
</script>
<style scoped>
.margin-Top-3Perc{
  margin-top: 3% !important;
}
/* Using Only for footer */
.footer{
  /* position: fixed; */
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/ManageContent.vue